module.exports = __webpack_public_path__ + "ee7849c34a0484657d4cd0c0dd00936f.MP3";